/* ===========================================================================
   Pawtrait Pop — theme behaviour
   No dependencies. Everything degrades gracefully without JS:
   the product form is a plain multipart POST to /cart/add.
   =========================================================================== */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------ mobile drawer -- */
  function initDrawer() {
    var drawer = document.querySelector('[data-pp-drawer]');
    if (!drawer) return;
    var openers = document.querySelectorAll('[data-pp-drawer-open]');
    var closers = drawer.querySelectorAll('[data-pp-drawer-close]');
    var lastFocused = null;

    function open() {
      lastFocused = document.activeElement;
      drawer.dataset.open = 'true';
      drawer.removeAttribute('aria-hidden');
      document.body.style.overflow = 'hidden';
      var first = drawer.querySelector('a, button');
      if (first) first.focus();
    }
    function close() {
      drawer.dataset.open = 'false';
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (lastFocused) lastFocused.focus();
    }

    openers.forEach(function (b) { b.addEventListener('click', open); });
    closers.forEach(function (b) { b.addEventListener('click', close); });
    drawer.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.dataset.open === 'true') close();
    });
  }

  /* ---------------------------------------------------- reveal on scroll -- */
  function initReveal() {
    var els = document.querySelectorAll('.pp-reveal');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });

    /* Failsafe: whatever happens, nothing stays invisible. If the observer has
       not revealed an element within 1.5s, show it anyway. */
    window.setTimeout(function () {
      els.forEach(function (el) { el.classList.add('is-in'); });
    }, 1500);
  }

  /* -------------------------------------------------------- product form -- */
  function initProduct() {
    var root = document.querySelector('[data-pp-product]');
    if (!root) return;

    var form = root.querySelector('[data-pp-form]');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var priceEls = root.parentNode ? document.querySelectorAll('[data-pp-price]') : [];
    var maxBytes = parseInt(root.dataset.maxUploadMb || '20', 10) * 1024 * 1024;

    /* -- variant pills keep the hidden id + every price display in sync -- */
    var variantData = {};
    var json = root.querySelector('[data-pp-variants]');
    if (json) {
      try {
        JSON.parse(json.textContent).forEach(function (v) { variantData[v.id] = v; });
      } catch (e) { /* leave prices as server-rendered */ }
    }

    root.querySelectorAll('[data-pp-variant]').forEach(function (input) {
      input.addEventListener('change', function () {
        if (!input.checked) return;
        if (idInput) idInput.value = input.value;
        var v = variantData[input.value];
        if (v && v.price_formatted) {
          priceEls.forEach(function (el) { el.textContent = v.price_formatted; });
        }
      });
    });

    /* ------------------------------------------ photo upload + preview -- */
    var uploads=[];
root.querySelectorAll("[data-pp-upload]").forEach(function(zone){
 var field=zone.closest("[data-pp-photo-field]"),input=zone.querySelector('input[type="file"]'),preview=zone.querySelector("[data-pp-preview] img"),nameEl=zone.querySelector("[data-pp-filename]"),errEl=field.querySelector("[data-pp-upload-error]"),remove=field.querySelector("[data-pp-remove-photo]");
 function reset(){input.value="";zone.dataset.hasFile="false";nameEl.textContent="";remove.hidden=true;preview.style.display="none";}
 function fail(message){reset();errEl.textContent=message;errEl.dataset.show="true";}
 function handle(file){errEl.dataset.show="false";if(!file){reset();return;}
  if(!/^image\//.test(file.type)&&!(!file.type&&/\.(jpe?g|png|heic|heif|webp)$/i.test(file.name))){fail("Please choose a JPG, PNG, HEIC or WebP photo.");return;}
  if(file.size>maxBytes){fail("Please choose a photo under "+maxBytes/1024/1024+" MB.");return;}
  nameEl.textContent=file.name;zone.dataset.hasFile="true";remove.hidden=false;preview.style.display="none";
  if(window.FileReader){var reader=new FileReader();reader.onload=function(e){preview.onload=function(){preview.style.display="";};preview.onerror=function(){preview.style.display="none";};preview.src=e.target.result;};reader.readAsDataURL(file);}
 }
 input.addEventListener("change",function(){handle(input.files&&input.files[0]);});
 remove.addEventListener("click",function(){reset();errEl.dataset.show="false";input.focus();});
 ["dragenter","dragover"].forEach(function(t){zone.addEventListener(t,function(e){e.preventDefault();zone.dataset.drag="true";});});
 ["dragleave","drop"].forEach(function(t){zone.addEventListener(t,function(e){e.preventDefault();zone.dataset.drag="false";});});
 zone.addEventListener("drop",function(e){var files=e.dataTransfer&&e.dataTransfer.files;if(!files||!files.length)return;if(files.length>1){errEl.textContent="Please add one photo in each box.";errEl.dataset.show="true";return;}try{input.files=files;handle(input.files[0]);}catch(error){errEl.textContent="Please tap this box to choose your photo.";errEl.dataset.show="true";}});
 uploads.push({input:input,zone:zone,fail:fail});
});
form&&form.addEventListener("submit",function(e){var missing=uploads.find(function(u){return u.input.required&&!(u.input.files&&u.input.files.length);});if(missing){e.preventDefault();missing.fail("Please add a group photo or your first pet photo.");missing.zone.scrollIntoView({behavior:reduceMotion?"auto":"smooth",block:"center"});missing.input.focus();}});
var sticky = root.querySelector('[data-pp-sticky]');
    var anchor = root.querySelector('[data-pp-atc-anchor]');
    if (sticky && anchor && 'IntersectionObserver' in window) {
      var so = new IntersectionObserver(function (entries) {
        sticky.dataset.show = entries[0].isIntersecting ? 'false' : 'true';
      }, { rootMargin: '-120px 0px 0px 0px' });
      so.observe(anchor);
    }
  }

  /* ------------------------------------------------------- cart quantity -- */
  function initCart() {
    document.querySelectorAll('[data-pp-qty-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        var form = input.closest('form');
        if (form) form.submit();
      });
    });
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn, { once: true });
  }

  ready(function () {
    initDrawer();
    initReveal();
    initProduct();
    initCart();
  });
})();
